import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ButtonModule } from 'primeng/button';
import { ChipsModule } from 'primeng/chips';
import { SidebarModule } from 'primeng/sidebar';
import { DirectivesModule } from '../directives/directives.module';
import { PipesModule } from '../pipes/pipes.module';
import { AddEquipmentComponent } from './add-equipment/add-equipment.component';
import { AddPhaseComponent } from './add-phase/add-phase.component';
import { AppLoaderComponent } from './app-loader/app-loader.component';
import { SidebarComponent } from './app-sidebar/sidebar/sidebar.component';
import { CustomNumberInputComponent } from './custom-number-input/custom-number-input.component';
import { ErrorHandlerComponent } from './error-handler/error-handler.component';
import { ModalComponent } from './modal/modal.component';
import { ServerPaginationComponent } from './server-pagination/server-pagination.component';
const COMPONENTS = [
  ErrorHandlerComponent,
  ServerPaginationComponent,
  AppLoaderComponent,
  ModalComponent,
  SidebarComponent,
  AddPhaseComponent,
  AddEquipmentComponent,
  CustomNumberInputComponent,
];
@NgModule({
  imports: [
    CommonModule,
    // FontAwesomeModule,
    RouterModule,
    AccordionModule.forRoot(),
    PaginationModule.forRoot(),
    FormsModule,
    BsDropdownModule,
    SidebarModule,
    ButtonModule,
    DirectivesModule,
    ReactiveFormsModule,
    ChipsModule,
    PipesModule
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class SharedComponentsModule { }
